import React, { Component } from 'react';
import PropTypes from 'prop-types';

const user = (ComponentToWrap) => {
  return class UserComponent extends Component {
    static contextTypes = {
      user: PropTypes.object.isRequired,
    }
    render() {
      const  { user }  = this.context;
      return (
        <ComponentToWrap {...this.props} user={user} />
      );
    }
  };
};

export default user;



// WEBPACK FOOTER //
// ./src/Auth/user.js